(ns teamoesterreich.admin-mode.ui-helper.preview-modal
  (:require [clojure.string :as str]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.open-in-browser :refer [open-in-browser]]
            [reagent.core :as r]
            ["react" :as react]
            ["react-oidc-context" :as roc]
            [teamoesterreich.element.backend-file :as backend-file]))

(defn modal-inner [open hash on-close]
  [mui/modal
   {
    :aria-labelledby  "simple-modal-title"
    :aria-describedby "simple-modal-description"
    :style            {:display        "flex"
                       :marginRight    "auto"
                       :marginLeft     "auto"
                       :alignItems     "center"
                       :height         "70vh"
                       :justifyContent "center"}
    :open             (or open false)
    }
   [:f> backend-file/wrapper {:hash hash :preview? true}
    (fn [{:keys [url content-type]}]
      [:div
       {:class "modal"
        :title "Klicken zum Schließen"}

       [:img {:onClick on-close
              :style   {:position  "relative"
                        :float     "right"
                        :maxWidth  "550px"
                        :minHeight "300px"}
              :alt     "Ansicht"
              :src     (cond
                         (and content-type (str/starts-with? content-type "image/"))
                         url

                         (= content-type "application/pdf")
                         "/svg/pdf_icon.svg"

                         :else
                         "/svg/file_icon.svg"
                         )}]
       [:br]
       [mui/button {:onClick   on-close
                    :startIcon (r/as-element [keyboard-arrow-left])
                    } "Schließen"]
       [:f> backend-file/download-wrapper hash
        (fn [url]
          (let [url (when url (js/URL. url))]
            (when url
              (.set (.-searchParams url) "inline" "true"))
            [:a {:href (str url) :target "_blank"}
             [mui/button {:startIcon (r/as-element [open-in-browser])
                          } "Neuer Tab"]]))]

       ])]])


(defn modal-by-path [!show-hash]
  [modal-inner (some? @!show-hash) @!show-hash #(reset! !show-hash nil)])


(defn modal [hash !show]
  (js/console.log "preview" @!show)
  [modal-inner @!show hash #(reset! !show false)]
  )


